const contact = {
  phone: '91 060 66 44',
  email: 'info@vivusonline.es',
  businessHours:
    'Lunes – Viernes / 8:00 – 21:00, Sábado / 9:00 – 20:00, Domingo / 9:00 – 19:00, Festivos nacionales / 9:00 – 14:00',
  termsAndConditionsText: 'Términos y condiciones',
  termsAndConditionsUrl: 'https://www.vivus.es/terminos-y-condiciones',
};

const es = {
  common: {
    ...contact,
    currency: 'EUR',
    currencySymbol: '€',
    days: 'días',
    contact_email: 'info@vivus.es',
    contact_phone: '91 290 77 88',
    logout: 'Cerrar sesión',
    goBack: 'Volver',
    months: 'meses',
    footer_text: contact,
  },
  validation: {
    required_field: 'Campo obligatorio.',
    wrong_format: 'Formato incorrecto.',
    too_short: 'Muy corto.',
    too_long: 'Muy largo.',
    need_number: 'Debe ser un número.',
    wrong_code: 'Código incorrecto.',
    wrong_format_dni: 'Formato DNI incorrecto',
    wrong_date: 'Fecha no válida.',
    wrong_format_email: 'Formato email incorrecto',
    wrong_postal_code: 'Código postal incorrecto.',
    agreement_required: 'Tienes que aceptarlo para continuar.',
    already_in_db_title: 'No hemos podido completar tu registro',
    already_in_db_text:
      'Si ya eres cliente, entra en el <a href="/login">área de clientes</a>. Para intentar registrarte de nuevo haz clic <a href="/first-loan/email">aquí</a> o llámanos al 91 290 77 88</a>.',
  },
  sessionExpired: {
    title: 'Din session har gått ut',
    text: 'Oroa dig inte, vi höll alla dina inmatade uppgifter på plats. Du behöver bara klicka på "Gå till inloggningssida" och använda dina referenser för att logga in och fortsätta processen från den plats du lämnade.',
    goToLogin: 'Gå till inloggningssida',
  },
  passwordRecovery: {
    title: 'Glömt lösenordet?',
    identificatorTitle: 'Skriv in din e-postadress',
    continue: 'Fortsätta',
    errors: {
      general: `Something went wrong. Please try again later or contact us.`,
    },
    fields: {
      id: { label: 'E-post' },
    },
  },
  temporaryPasswordSent: {
    title: 'Tillfälligt Lösenord skickas till din e-post',
    text: 'Vi har skickat ett tillfälligt lösenord till din e-post, som du nu kan använda för att logga in.',
    login: 'logga in',
  },
  login: {
    title: 'Logga in på ditt konto',
    login: 'logga in',
    forgotPassword: 'Kommer du inte ihåg ditt lösenord?',
    errors: {
      wrong_credentials:
        'Email, DNI/NIE o contraseña incorrectos. Por favor, comprueba tus datos e inténtalo de nuevo.',
    },
    fields: {
      id: { label: 'E-post' },
      password: { label: 'Lösenord' },
    },
  },
  setNewPassword: {
    title: 'Skapa ett nytt lösenord',
    save: 'Spara',
    fields: {
      newPassword: { label: 'Nytt lösenord' },
      reenterNewPassword: { label: 'Ange nytt lösenord' },
    },
    errors: {
      passwordsDoesNotMatch: 'Lösenorden matchar inte.',
    },
  },
  passwordChanged: {
    title: 'Lösenordet harändrats',
    gotIt: 'Jag förstår',
  },
  paylandFailed: {
    body: 'Puedes intentarlo de nuevo en unos minutos o utilizar otra tarjeta. Si tienes preguntas llámanos al  <strong><a href="tel:912907788">912 907 788</a></strong>.',
    title: 'Lo sentimos, el pago por tarjeta ha fallado',
    primaryBtn: 'ENTENDIDO',
    secondaryBtn: 'Elige otro método de pago',
  },
  autoRepaymentSuccess: {
    bodyTitle: 'Una vez procesado el pago:',
    bodyOption1: '- Recibirás confirmación vía SMS (en unos minutos)',
    bodyOption2:
      '- Actualizaremos la información de tu préstamo en tu área de cliente',
    primaryBtn: 'ENTENDIDO',
    title: 'Pago en proceso',
  },
  BankAccount: {
    cardGreenTitle: 'ACUÉRDATE:',
    cardGreenMsg1: 'El IBAN no es el número de tu tarjeta bancaria',
    cardGreenMsg2:
      'Puedes encontrar tu número de cuenta IBAN en tu banco online y copiarlo desde allí',
    cardGreenMsg3:
      'Si no encuentras tu número de IBAN, contacta con tu banco y pide ayuda',
    cardHelper: 'Ejemplo:',
    cardTitle: 'Tu cuenta bancaria',
    continueBtn: 'Continuar',
    error:
      'El número introducido contiene errores. Si necesitas ayuda, contacta con nosotros 912907788.',
    subtitle:
      'Necesitamos tu cuenta bancaria para enviarte el dinero cuando tu préstamo sea aprobado.',
    title: 'Tu cuenta bancaria',
    questionLink: '¿Qué es el IBAN?',
    modalTitle: '¿Qué es el IBAN?',
    modalText:
      '<p>Las siglas IBAN (International Bank Account Number) significan Código Internacional de Cuenta Bancaria en español.</p>\n<p>El IBAN <strong>llegó en 2014 para sustituir al desaparecido CCC</strong>, que se correspondía con las siglas Código Cuenta Cliente y hace referencia a los veinte dígitos que identificaban a las cuentas corrientes bancarias en nuestro país.</p>\n<p>Con la intención de <strong>homogeneizar las operaciones bancarias entre los países de la zona euro</strong> nació el IBAN que sirve para identificar nuestras cuentas bancarias. La composición del IBAN es alfanumérica  y la forman 24 caracteres. La explicamos:</p>\n<ol>\n<li>Los cuatro primeros caracteres son <strong>dos letras que identifican al país</strong> (en España, ES) y dos números que son un código de control.</li>\n<li>Los cuatro siguientes son <strong>números que identifican a la entidad bancaria.</strong></li>\n<li>Cuatro números más que hacen referencia al <strong>código de la sucursal.</strong></li>\n<li>Por último, <strong>doce números hasta completar los 24</strong> que forman el IBAN.</li>\n</ol>\n<p>Por ejemplo: ES00 1111 2222 333333333333</p>\n<p>En realidad el IBAN es exactamente igual al ya extinto CCC pero anteponiéndole el código alfanumérico ESXX en el caso de España, donde XX son los dígitos de control.</p>\n<p>Puedes encontrar tu número de IBAN en <strong>los detalles de tu cuenta en el servicio de banca online</strong> de tu banco.</p>',
  },

  emailDocumentation: {
    backBtn: 'Volver',
    cardHelper:
      'Si no puedes enviarnos los documentos ahora, toma nota de nuestro E-mail para enviarlos más tarde y continúa con el proceso.',
    cardSubtitle: 'Envíanos las fotografías antes de que tu solicitud expire:',
    cardTitle: 'Envía tu documentación por E-mail',
    confirmBtn: 'CONFIRMAR ENVÍO',
    helperDNI: 'DNI / NIE (DELANTERA) + (TRASERA)',
    helperReceipt: 'JUSTIFICANTE DE TITULARIDAD DE LA CUENTA',
    subtitle:
      '<div>Haz una foto o escanea tu <strong>DNI / NIE</strong> (por ambas caras) y el <strong>justificante de titularidad</strong> de tu cuenta bancaria.</div>',
    title: 'Envía tu documentación por E-mail',
  },

  registrationHeader: {
    interest: 'Interest',
    period: 'Period',
    requestedAmount: 'Requested amount',
    returnDate: 'Return date',
    totalToReturn: 'Total to return',
  },

  summary: {
    title: 'Resumen',
    amount: 'Importe',
    duration: 'Plazo',
    interest: 'Intereses',
    repayable_amount: 'Total a devolver',
    repayment_date: 'Fecha de devolución',
    edit: 'EDITAR SOLICITUD',
    secured: 'Confianza asegurada',
  },

  progress: {
    intro: 'Empieza tu solicitud',
    identification: 'Regístrate',
    confirmation: 'Identifícate',
    summary: 'Recibe tu dinero',
  },

  intro: {
    html_title: 'Solicita tu primer préstamo - vivus.es',
    title: 'Solicita tu primer préstamo',
    existing_customer_title: '¿Ya eres cliente?',
    existing_customer_link: 'Inicia sesión',
    requirements_title: 'Requisitos:',
    requirements_item_id: 'Residir en España y tener DNI o NIE en vigor',
    requirements_item_adult: 'Ser mayor de edad',
    requirements_item_bank: 'Ser titular de una cuenta bancaria española',
    faster_checkout_title: 'Para agilizar tu solicitud:',
    faster_checkout_item_bank_internet_access:
      'Identifícate con tu banco online',
    start_button: 'EMPEZAR',
  },

  contact: {
    title: 'Datos de contacto',
    email_input_label: 'E-mail',
    phone_input_label: 'Teléfono móvil',
    continue_button: 'CONTINUAR',
  },

  loan_approved: {
    callout: {
      title: 'Tiempo aproximado para recibir\nel dinero en tu cuenta',
      description:
        'Por favor, revisa el <strong>SMS</strong> y el <strong>E-mail</strong> que te hemos\nenviado donde podrás encontrar la documentación\nrelativa a tu crédito.\nSi tienes alguna duda, llámanos al <strong>91 290 77 88</strong>',
      bank_account_transaction: 'El dinero será transferido a esta cuenta:',
    },
  },

  create_account: {
    title: 'Crea tu cuenta',
    id_input_label: 'Ejemplo: 12345678A / X1234567B',
    id_input_placeholder: 'Número de DNI / NIE',
    password_input_label:
      'La contraseña debe contener al menos 6 caracteres, letras y números, y al menos uno de ellos ha de ser un número',
    password_input_placehold: 'Contraseña',
    continue_button: 'CREAR TU CUENTA',
    details:
      'Puedes estar tranquilo/a, en Vivusonline.es utilizamos la última tecnología para mantener tus datos encriptados y protegidos.',
  },

  landing: {
    title: 'Solicita tu primer préstamo',
    session_title: '¿Ya eres cliente?',
    session_link: 'Inicia sesión',
    request_title: 'Requisitos:',
    speedup_title: 'Para agilizar tu solicitud:',
    continue_button: 'EMPEZAR',
    id_text: 'Residir en España y tener DNI o NIE en vigor',
    adult_text: 'Ser mayor de edad',
    owner_account_text: 'Ser titular de una cuenta bancaria española',
    bank_text: 'Identifícate con tu banco online',
    user_title: '¿Ya has tenido un préstamo Vivus?',
    user_description:
      'Entra en tu área de cliente para ver las opciones disponibles',
    user_link: 'Ir a mi área de cliente',
    user_link_href: 'https://account.vivus.es/login?online',
  },

  identification: {
    title: 'Datos de contacto',
    email_placeholder: 'E-mail',
    phone_placeholder: 'Teléfono móvil',
    first_agreement:
      'Acepto recibir información sobre descuentos, promociones, ofertas especiales y novedades de 4FINANCE SPAIN FINANCIAL SERVICES SA y las empresas del Grupo <a href=&quot;#&quot;>(más información sobre tratamiento de datos)</a>.',
    second_agreement:
      'Autorizo a que mis datos personales sean comunicados a partners con los que 4FINANCE SPAIN FINANCIAL SERVICES, SAU hayan alcanzado acuerdos, para que puedan informarme sobre sus productos o servicio <a href=&quot;#&quot;>(más información)</a>',
    third_agreement:
      'He leído y acepto los <a href="https://www.vivusonline.es/condiciones-generales" target="_blank">Términos y Condiciones</a>, la <a target="_blank" href="https://www.vivusonline.es/politica-de-privacidad" >Política de Privacidad</a> y la <a target="_blank" href="https://www.vivusonline.es/informacion-sobre-el-prestamo?amount={amount}">Información Europea Normalizada del Contrato</a>.',
    continue_button: 'CONTINUAR',
    details:
      'Puedes estar tranquilo/a, en Vivus.es utilizamos la última tecnología para mantener tus datos encriptados y protegidos.',
    additionalInfo:
      '<b>4Finance</b> tratará sus datos para gestionar su registro legitimado en la correcta ejecución de los servicios solicitados. En caso de otorgar su consentimiento, tratará sus datos para informarle nuestros productos, y de los de nuestros partners. Más información en <a target="_blank" href="https://www.vivusonline.es/politica-de-privacidad" >Política de Privacidad</a>. Delegado de Protección de Datos: <a href="mailto:dpd@4finance.com">dpd@4finance.com</a>.',
  },

  registration_header: {
    title_amount: 'Elige la cantidad que quieras',
    title_days: 'Elige los dias que necesitas para el aplazamiento',
    title_modal: 'Información sobre el préstamo',
  },

  phone_verification: {
    heading: 'Verifica tu teléfono',
    subheading: 'Introduce el código que te hemos enviado vía SMS',
    resend_code: 'Reenvíame el código',
    time_remaining: 'Podemos reenviarte el código en',
    submit_button: 'Continuar',
    change_phone_text_1:
      'Si tu teléfono no es <strong>{phoneNumber}</strong>, haz clic ',
    change_phone_link_text: 'aquí',
    change_phone_text_2:
      ' o llama al <a href="tel:910606644">91 060 66 44</a>.',
  },

  incorrect_code: {
    heading: 'Código incorrecto',
    subheading:
      'Introduce de nuevo tu número de teléfono móvil para recibir un código nuevo.',
    mobile_phone: 'Teléfono móvil',
    continue_button: 'Continuar',
  },

  phone_change: {
    heading: 'Cambiar el número de teléfono',
    subheading:
      'Introduce de nuevo tu número de teléfono móvil para recibir un código nuevo.',
    mobile_phone: 'Teléfono móvil',
    continue_button: 'Continuar',
  },

  requestDenied: {
    backBtn: 'Volver a la portada',
    messageGreen:
      'Lo sentimos, en este momento no podemos ofrecete un préstamo',
    messageSecondary:
      'Si tu situación personal cambia en el futuro, puedes volver a contactar con nosotros para conseguir la financiación que necesites.',
    messageStrong: 'No es un "no" para siempre',
    title: 'Solicitud denegada',
    frequentCausesTitle: 'Las causas más frecuentes de denegación son',
    frequentCauseOne: 'Un histórico de impago con nosotros en el pasado.',
    frequentCauseTwo: 'Estar incluido en un fichero de morosidad.',
    frequentCauseThree: 'Tener otro crédito abierto actualmente con nosotros.',
  },

  requestLoading: {
    title: 'Comprobando tu información',
    subtitle:
      'Por favor, no cierres la ventana todavía.\nEste proceso puede tardar unos minutos.',
  },

  activePayment: {
    activateBtn: 'ACTIVAR',
    message:
      'No haremos ningún cargo en tu tarjeta hasta que llegue la fecha de pago de tu préstamo',
    title: '¡Activa el pago automático y paga de forma cómoda y segura!',
  },

  requestSuccess: {
    messageGreen:
      'Te llamaremos lo antes posible para confirmar algunos datos una vez sean revisados tus documentos. Te comunicaremos el resultado de tu solicitud en esta misma llamada.',
    title: 'Ya casi estamos',
    titleMessageGreen: '¡No te separes de tu móvil!',
  },

  uploadCard: {
    remove: 'Eliminar',
    searchFile: 'Seleccionar archivo',
  },

  uploadDocumentation: {
    btnAdditionalDocument: 'Documentos adicionales',
    btnBack: 'Volver',
    btnContinue: 'CONTINUAR',
    uploadWarning:
      'Tamaño máximo permitido: <strong>25 MB</strong>, en formato JPG, PNG, BMP, GIF o PDF',
    formatError: 'El formato o tamaño del archivo no es válido',
    modalBtnContinue: 'CONTINUAR',
    modalTitle: 'COMPRUEBA:',
    modalLine1: '¿La foto es nítida y legible?',
    modalLine2: '¿Muestra el documento completo?',
    modalLine3: '¿Está hecha sobre un fondo neutro?',
    option1: 'Parte delantera DNI / NIE',
    option2: 'Parte trasera DNI / NIE',
    option3: 'Justificante bancario reciente a tu nombre',
    subtitle:
      'Necesitamos verificar tu identidad y comprobar los datos de un justificante bancario reciente.',
    title: 'Subir documentación',
    secured: 'Seguro',
  },

  verifyOptions: {
    back_btn: 'Volver',
    options: {
      option1: 'Banco Online',
      option2: 'Subir documentación + llamada telefónica',
      option3: 'Enviar documentación por E-mail + llamada telefónica',
    },
    subtitle:
      '<bolder>AVISO:</bolder> Elige Banco Online para agilizar el proceso y evitar la necesidad de enviar documentación.',
    title: 'Opciones para verificarte',
  },

  countdown: {
    secondsShort: 's',
    minutesShort: 'm',
    hoursShort: 'h',
  },

  personal_data: {
    title: 'Datos personales',
    subtitle_heading: 'Importante',
    subtitle_text:
      'Introduce los datos tal y como aparecen en tu documento de identidad.',
    first_name: 'Nombre completo',
    first_surname: 'Primer apellido',
    second_surname: 'Segundo apellido',
    surname_checkbox: 'No tengo segundo apellido',
    birthdate: 'Fecha de nacimiento',
    birthdate_day_placeholder: 'DD',
    birthdate_month_paceholder: 'MM',
    birthdate_year_placeholder: 'AAAA',
    birthdate_description:
      'Necesitamos saber tu edad para asegurarnos de que cumples los requisitos para solicitar el préstamo.',
    birthdate_field_group_label_text: 'Fecha de nacimiento',
    continue_button_text: 'Continuar',
  },

  address_details: {
    title: 'Tu dirección',
    address_placeholder: 'Dirección',
    address_number_placeholder: 'Número',
    address_floor_placeholder: 'Piso',
    address_letter_placeholder: 'Letra',
    address_postal_code_placeholder: 'Código Postal',
    address_province_placeholder: 'Provincia',
    address_city_placeholder: 'Ciudad',
    continue_button_text: 'Continuar',
  },

  income_details: {
    title: 'Tus ingresos',
    income_source_placeholder: 'Fuente de ingresos',
    avg_income_source_placeholder: 'Ingresos medios mensuales',
    description: 'Es posible que tengamos que solicitar un justificante',
    continue_button_text: 'Continuar',
    employment_status: {
      HOUSEWIFE: 'Ama de casa',
      STUDENT: 'Estudiante',
      NON_PROFIT: 'Empleado de la ONCE',
      MERCHANT: 'Venta ambulante',
      AGRICULTURE: 'Empleado sector agrario',
      PERMANENT_CONTRACT_PUBLIC: 'Contrato fijo (público)',
      TERM_CONTRACT_PUBLIC: 'Contrato temporal (público)',
      PERMANENT_CONTRACT_PRIVATE: 'Contrato fijo (privado)',
      TERM_CONTRACT_PRIVATE: 'Contrato temporal (privado)',
      PRE_RETIRED: 'Prejubilado',
      RETIRED: 'Jubilado',
      PENSIONER: 'Pensionista',
      UNEMPLOYED_GAINING_SUPPORT: 'Desempleado con prestación',
      UNEMPLOYED_CHARGING_PROVISION: 'Desempleado sin prestación',
      SELF_EMPLOYED: 'Autónomo',
      MILITARY: 'Militar, policía, guardia civil',
    },
  },
  welcome: {
    title: '¡Hola de nuevo!',
    subtitle:
      'Tienes una solicitud sin terminar. Termina el proceso para conseguir tu préstamo.',
    table_title: 'Datos de tu préstamo',
    edit_button: 'Editar solicitud',
    continue_button: 'Continuar',
    table: {
      row1: 'Importe solicitado',
      row2: 'Intereses',
      row3: 'Total a devolver',
      row4: 'Fecha de devolución',
    },
  },
  online_bank_identification: {
    rejected_by_bank: {
      title: 'Resultado no concluyente',
      cardTitle:
        'No hemos podido tomar una decisión con los datos de tu cuenta bancaria.',
      option: 'Opción {number}',
      option1:
        'Conecta a otro banco online acuérdate de utilizar la cuenta que usas más a menudo',
      option2: 'Llámanos al',
      buttonText: 'Conecta a otro banco',
      phone: '912 907 788',
    },
    tink_verification: {
      check_points: {
        approved: 'Mayor probabilidad de aprobación',
        banks: 'Tink facilita soluciones a más de 300 bancos y entidades',
        connection: 'Conexión segura con tu banco',
        european_bank: 'Tink está regulado por el Banco Central Europeo',
      },
      footer_card:
        'Tink facilita soluciones a más de 300 bancos y entidades como:',
      helper_first_part: 'Si no tienes banco online, haz click',
      helper_click_part: 'aquí',
      info_box: {
        security:
          '- Tink utiliza la seguridad de tu propio banco y conecta <bolder>solo una vez</bolder> para confirmar tu identidad sin realizar ninguna operación bancaria',
        transfer: '- El dinero será transferido a tu cuenta principal',
      },
      title: 'Verifica tu identidad con Tink',
      submit_btn: 'Verificar mi identidad',
      submit_footer:
        'Consiento que Tink recoja, utilice y transfiera mi información bancaria, incluyendo transacciones a 4Finance a través de su servicio.',
      warning_card: '¡Te quedan solo 2 minutos para terminar tu solicitud!',
      warning_footer_title: 'Información sobre el servicio de Identificación',
      warning_footer_description:
        'Tink se conectará con tu banco online para extraer el número de cuenta bancaria al que transferiremos automáticamente el dinero. Si eres titular de varias cuentas, el dinero será transferido a la principal, la cual se determina según el número de titulares, ingresos y transacciones.',
    },
    loan_manual_approved: {
      cardBody: 'En el caso de aprobación, recibirás el dinero en la cuenta:',
      cardSubtitle:
        'Comunicaremos el resultado de tu solicitud vía <strong>E-mail</strong> o <strong>SMS</strong> lo antes posible',
      cardTitle: 'Nuestro equipo tiene que confirmar un par de datos',
      title: 'Casi estamos',
    },

    loan_approved: {
      AgreedBtn: 'ENTENDIDO',
      cardLine1: 'Recibirás el dinero en la cuenta',
      cardLine2: 'En los próximos',
      cardLine3:
        'Te hemos enviado vía <strong>E-mail</strong> y <strong>SMS</strong> la documentación de tu préstamo.',
      cardLine4:
        'Si tienes alguna duda, llámanos al <strong>91 290 77 88</strong>',
      title:
        '<strong>Dinero en camino</strong><br /><span>¡Tu préstamo ha sido aprobado!</span>',
    },

    waiting: {
      title: 'Comprobando tu información',
      subtitle:
        'Por favor espere, no cierre esta ventana.<br/>Este proceso puede tardar hasta 5 minutos.',
    },

    errorCode: {
      title: 'Lo sentimos',
      cardText: 'Algo ha ido mal. Por favor, intenta de nuevo en unos minutos.',
      buttonText: 'Inténtalo de nuevo',
    },
  },

  business_hours:
    'Lunes – Viernes / 8:00 – 21:00, Sábado / 9:00 – 20:00, Domingo / 9:00 – 19:00, Festivos nacionales / 9:00 – 14:00',

  calculator: {
    title: 'Edita tu solicitud',
    confirmChanges: 'CONFIRMAR CAMBIOS',
    openLoanInformationModal: 'INFORMACIÓN SOBRE EL PRÉSTAMO',
  },
  affiliates: {
    repeatedLoanConfirm: {
      bankAccount: 'Cuenta bancaria',
      bankAccountHelper:
        'Si has cambiado de cuenta o quieres recibir el dinero en otra, por favor, contacta con nosotros llamando al 91 290 77 88 antes de confirmar tu solicitud',
      checkTerms:
        'He leído y acepto los <a href="#">Términos y condiciones</a> y la <a href="#">Información Europea Normalizada del Contrato</a>',
      confirmBtn: 'CONFIRMAR SOLICITUD',
      table: {
        row1: 'Plazo',
        row2: 'Pago mensual&nbsp <span>|</span>&nbsp<a href="payment">Ver plan de pago</a>',
        row3: 'Total a devolver',
        row4: 'Importe solicitado',
        row5: 'Intereses',
        row6: 'Fecha de última pago',
      },
      title: 'Revisa y confirma tu solicitud',
    },
    repeatedLoanRejected: {
      agreedBtn: 'ENTENDIDO',
      title: 'Lo sentimos, en este momento no podemos ofrecerte un préstamo',
      msg1: 'Las causas más frecuentes por las que no somos capaces de ofrecerte un préstamo son:<br />Haber tenido algún impago con nosotros en el pasado; Estar incluido en ficheros de morosidad;<br />Tener algún otro crédito abierto en estos momentos.',
      msg2Strong: '<strong>Seguimos en contacto</strong>',
      msg3: 'Nos gustaría poder ofrecerte un crédito en el futuro, por lo que no dejes de contactar de nuevo con nosotros pasado un tiempo.',
    },
    repeatedLoanSuccess: {
      agreedBtn: 'ENTENDIDO',
      card: {
        helperBankAccount: 'El dinero será transferido a esta cuenta:',
        helperNotification:
          'Por favor, revisa el <strong>SMS</strong> y el <strong>E-mail</strong> que te hemos enviado donde podrás encontrar la documentación relativa a tu crédito.',
        title: 'Tiempo aproximado para recibir el dinero en tu cuenta',
      },
      title:
        '<strong>Dinero en camino</strong><br /><span>¡Tu préstamo ha sido aprobado!</span>',
    },
    sections: {
      welcome: 'Welcome',
      identification: 'Identifícate',
      receive: 'Recibe tu dinero',
    },
    firstapplication: {
      title: 'Bienvenido a Vivus.es',
      title_mobile: `Bienvenido José, comprueba tus datos y continua para conseguir tu préstamo.`,
      sub_title: 'Hemos pre-aprobado tu solicitud',
      table: {
        title: 'Detalle del préstamo',
        amount_request: 'Importe solicitado',
        interests: 'Intereses',
        return_total: 'Total a devolver',
        return_date: 'Fecha de devolución',
        sub_title: '(Haz clic en el botón SOLICITAR y obtén tu préstamo)',
      },
      authorization_company:
        'Autorizo a 4FINANCE SPAIN FINANCIAL SERVICES, SA y las Empresas del Grupo a que traten mis datos personales proporcionados con fines publicitarios y de marketing <a href=&quot;#&quot;>(más información).</a>',
      authorization_me:
        'Autorizo a que mis datos personales sean comunicados a partners con los que 4FINANCE SPAIN FINANCIAL SERVICES, SAU hayan alcanzado acuerdos, para que puedan informarme sobre sus productos o servicio <a href=&quot;#&quot;>(más información)</a>.',
      terms_condition:
        'He leído y acepto los <a href=&quot;#&quot;>Términos y Condiciones, la Política de Privacidad y la Información Europea Normalizada del Contrato</a>, y consiento que mis datos personales sean procesados de conformidad con las Condiciones Generales y la Política de Privacidad.',
      button: 'SOLICITAR',
      button_sub_title: 'Aumentar cantidad del préstamo',
      faq: {
        header: 'Preguntas Frecuentes',
        items: [
          {
            question:
              'Necesito más dinero, ¿cómo puedo ampliar la cantidad de mi préstamo?',
            answer:
              '<p>¿Has pedido uno de nuestros préstamos Vivus pero te has dado cuenta de que necesitas más dinero? Con los préstamos Vivus puedes ampliar la cantidad de tu préstamo online en cualquier momento con tan solo acceder a <a href=&quot;#&quot;>tu área de cliente Vivus</a> y después de comprobar si tu límite de crédito actual te lo permite.</p><p><strong>Tienes dos opciones para ampliar la cantidad de tu crédito:</strong></p><ol>  <li>Si es tu primer préstamo, tu límite de crédito son 300 euros (si tienes 24 años o más), por lo que solo podrías pedir un importe adicional en caso de que hubieras pedido menos de 300 euros. Por ejemplo: si has pedido un primer préstamo de 150 euros, podrías solicitar un importe adicional de 150 euros hasta llegar al total de tu límite de crédito de 300. En este caso, al ser un primer préstamo, el importe adicional seguiría sin tener intereses ni comisiones.</li>  <li>Si es un segundo préstamo o sucesivos, en función de la cantidad de créditos que hayas devuelto a fecha de vencimiento, tu límite de crédito irá aumentando progresivamente hasta un máximo de 1.100 euros. Por ejemplo, si eres cliente desde hace tiempo en Vivus y tu límite de crédito son 800 euros y hoy has pedido un préstamo de 300 euros, podrías disponer en cualquier momento de un importe adicional de hasta 500 euros.</li></ol><p>Recuerda que aunque pidas más dinero, <strong>la fecha de vencimiento de tu préstamo sigue siendo la misma</strong>.</p><p>Puedes solicitar una cantidad adicional <strong>tantas veces como quieras hasta llegar al máximo permitido por tu límite de crédito</strong>. Si tu límite de crédito son 1.000 euros, y en un principio has pedido solo 500, podrías solicitar los otros 500 de una vez, o repartido de la forma que mejor te convenga. Pero recuerda: la fecha de vencimiento seguirá siendo la misma.</p>',
          },
          {
            question:
              '¿Para solicitar un primer préstamo tengo que enviar documentación?',
            answer:
              '<p>Si realizas la identificación automática (a través de Instantor) podrás conocer si tu préstamo rápido es aprobado inmediatamente. Por el contrario, si eliges realizar la identificación manual, entonces tendrás que enviarnos una foto de la parte frontal y trasera de tu DNI / NIE así como del justificante bancario en el que consten los datos de la cuenta y del titular de la misma (puede ser, por ejemplo, el certificado de titularidad de la cuenta).</p>',
          },
          {
            question: '¿El primer crédito es completamente gratis?',
            answer:
              '<p>El primer préstamo de hasta 300€ es sin intereses ni comisiones, por lo que es completamente gratuito. Por ejemplo: Si solicitas un préstamo de 300€ a devolver en 30 días, solamente tendrás que devolver 300€ transcurridos los 30 días. Así de fácil.3</p>',
          },
        ],
      },
      modal: {
        title: '¿Necesitas más dinero?',
        text: 'Al ser tu primer préstamo, tu límite de crédito son 300 € (sin intereses). Sin embargo, con los préstamos Vivus puedes ampliar la cantidad de tu préstamo online en cualquier momento con tan solo acceder a tu área de cliente Vivus y después de comprobar si tu límite de crédito actual te lo permite. Además, en función de la cantidad de créditos que hayas devuelto a fecha de vencimiento, tu límite de crédito irá aumentando progresivamente hasta un máximo de 1.400 €.',
        button: 'OK',
      },
    },
  },
  notification: {
    text: 'Te has retrasado 7 días en el pago. Por favor, contacta con nosotros si estás teniendo dificultades para devolver el préstamo',
  },
  notFound: {
    title: 'La página no fue encontrada..',
    subtitle:
      'Algo ha salido mal. Lamentablemente, la página a la que quiere acceder no existe.',
    buttonText: 'Volver a casa',
  },
};

export default es;
